import React, { useEffect, useState, useRef } from "react";
import "./fileupload.css";
import { ReactComponent as PlaySVG } from "../../assets/Svg/Watch.svg";
import { BsPlayCircle } from "react-icons/bs";
import { IoCloudUpload } from "react-icons/io5";
import { AiFillCloseCircle } from "react-icons/ai";
import { fileToBase64 } from "./base64Converter/base64Convertor";
import Modal from "react-modal";
import FilePreview from "./FilePreview";
import { FaFilePdf } from "react-icons/fa6";
import { SiMicrosoftexcel } from "react-icons/si";
import { FcImageFile } from "react-icons/fc";
import { IoDocumentsOutline } from "react-icons/io5";
import { MdImage } from "react-icons/md";
import { IoDocumentSharp } from "react-icons/io5";
import FailModal from "../Common/Popups/FailModal";

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

// export const handleFileSizeExceed = (setFailMessage, setOpenFailModal) => {
//   setFailMessage("File size limit exceeded. Please ensure that the file size does not exceed 2 MB");
//   setOpenFailModal(true);
// };


export const closeModal = (setPreviewModal) => {
  setPreviewModal(false)
}

export const handleSelectFile = (inputRef) => {
  inputRef.current.click();
};


export const handleRemove = (index, files, setFiles, setFormData) => {
  const updatedFiles = [...files];
  updatedFiles.splice(index, 1);
  
  setFormData((prevState) => ({
    ...prevState,
    attachmentDocuments: prevState?.attachmentDocuments?.filter((item, fileIndex) => fileIndex !== index),
  }));

  setFiles(updatedFiles);
};


export const fixBase64String = (malformedBase64) => {
  // Remove data URI prefix if present
  const base64WithoutPrefix = malformedBase64.replace(/^data:[^;]+;base64,/, '');

  // Replace URL-safe characters
  const base64Standardized = base64WithoutPrefix.replace(/-/g, '+').replace(/_/g, '/');

  // Add padding if necessary
  const padding = '='.repeat((4 - base64Standardized.length % 4) % 4);
  const validBase64 = base64Standardized + padding;

  return validBase64;
}

export const handleSelectSingle = async ({ filesArr, fileToBase64, handleFormChange }) => {
  let fileObjects = [];

  for (let i = 0; i < filesArr.length; i++) {
    const file = filesArr[i];
    const base64 = await fileToBase64(file);
    const fileObj = {
      fileName: file.name,
      fileType: file.type,
      attachment: base64,
    };
    fileObjects.push(fileObj);
  }

  handleFormChange("attachmentDocuments", fileObjects);
};



const FileUpload = ({ handleFormChange, setFormData, flow, actualData, formData, isDisabled }) => {
  const [files, setFiles] = useState([]);
  const [filesLength, setFilesLength] = useState(0)
  const [previewModal, setPreviewModal] = useState(false)

  const [selectedFile, setSelectedFile] = useState({
    base64String: "",
    fileType: ""
  })

  const [openFailModal, setOpenFailModal] = useState(false);

  const [failMessage, setFailMessage] = useState("");



  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);


  // const handleOpenFailModel = () => {
  //   setOpenFailModal(true);
  // }

  useEffect(() => {
    if (actualData) {
      setFiles(actualData)
    }
  }, [actualData])


  useEffect(() => {
    setFilesLength(files.length);
  }, [])

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };


  const handleDrop = async (e) => {
    e.preventDefault();
    const newFiles = [...e.dataTransfer.files];

    let limitExcedded = false;

    newFiles.forEach((f) => {

      if (f.size > 1572864) {
        limitExcedded = true;
      }
    });



    if (!limitExcedded) {
      const fileObjects = [];
      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const base64 = await fileToBase64(file);

        const fileObj = {
          fileName: file.name,
          fileType: file.type,
          attachment: base64,
        };

        fileObjects.push(fileObj);
      }
      setDragging(false);
      handleFormChange("attachmentDocuments", fileObjects);
      setFiles([...files, ...newFiles]);
    }
    // else {
    //   handleFileSizeExceed(setFailMessage, setOpenFailModal)
    // }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  // const handleRemove = (index) => {
  //   const updatedFiles = [...files];
  //   updatedFiles.splice(index, 1);
  //   setFormData((prevState) => {

  //     return { ...prevState, "attachmentDocuments": prevState?.attachmentDocuments?.filter((item, fileIndex) => fileIndex !== index) }
  //   })
  //   setFiles(updatedFiles);
  // };



  return (
    <div
      className={"file-upload-container"}
      onDrop={handleDrop}
      data-testid="drop-zone"
      onDragOver={handleDragOver}
      style={{
        width: "100%",
        minHeight: "40px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        textAlign: "center",
        // paddingTop: '80px',
        fontSize: "1rem",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#B8B8B8",
        position: "relative",
      }}
    >
      {
        files?.length == 0 &&
        <span className="inner-field" data-testid="inner-field" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "15px", width: '100%' }}>
          <span className={!isDisabled ? "drop-label click-btn" : "hover-functionality"} onClick={()=>handleSelectFile(inputRef)}>Click to upload </span>
          <span className="drop-label" style={{ color: "#777B85" }} >or drag and drop</span>

          {<div className="upload-btn" data-testid="upload-btn" style={{ cursor: "text", paddingTop: 10 }} onClick={() => filesLength !== 0 && handleSelectFile(inputRef)}>
            {!isDisabled ? <IoCloudUpload fill="#00aff1" /> : <IoCloudUpload fill="gray" />}
          </div>}
        </span>
      }

      <ul className="file-list" data-testid="fixBase64String">
        {formData?.attachmentDocuments?.map((file, index) => (
          <div className="file-list-item" key={index}>
            {file.fileType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? <div className="fupload-icon-cont"><SiMicrosoftexcel size={"12px"} /></div> : file.fileType == "application/pdf" ? <div className="fupload-icon-cont"><FaFilePdf size={"12px"} /></div> : file.fileType == "image/jpeg" || file.fileType == "image/png" ? <div className="fupload-icon-cont"><MdImage size={"12px"} /></div> : <div className="fupload-icon-cont"><IoDocumentSharp size={"12px"} /></div>}

            <div
              onClick={() => {
                let validStr = fixBase64String(file?.attachment)
                setSelectedFile({ base64String: validStr, fileType: file?.fileType })
                setPreviewModal(true)
              }}
              style={{ color: "#000", fontSize: "14px", marginRight: "15px" }}
              data-testid="fixBase64String"
            >
              {file?.fileName}
            </div>
            {!isDisabled && <AiFillCloseCircle size={"17px"} fill="#E85957" data-testid="AiFillCloseCircle" onClick={() => handleRemove(index, files, setFiles, setFormData)} />}
          </div>
          //   <li className='file-list-item' key={index}  style={{ cursor: 'pointer' }}>
          //     {file.name}
          //   </li>
        ))}
      </ul>
      {
        // <button type="button" onClick={(e) => handleSelectFile(e)}>Browse for file</button>
        files?.length !== 0 &&
        <div className="upload-btn" style={{ padding: '3px 10px 0px 0px', cursor: files?.length !== 0 && "pointer" }} data-testid="IoCloudUpload" onClick={() => handleSelectFile(inputRef)}>
          <IoCloudUpload fill="#00aff1" />
        </div>
      }
      <input
        ref={inputRef}
        type="file"
        data-testid="inputRef"
        multiple
        name="attachmentDocuments"
        onChange={(e) => {

          let limitExcedded = false;

          [...e.target.files]?.map((f) => {

            if (f.size > 1572864) {
              limitExcedded = true;
            }
            return null;
          });


          if (!limitExcedded) {

            setFiles([...files, ...e.target.files]);
            handleSelectSingle({
              filesArr: e.target.files,
              fileToBase64,
              handleFormChange
            });
          }
          // else {
          //   handleFileSizeExceed(setFailMessage, setOpenFailModal)
          // }
        }}
        style={{ display: "none" }}
      />
      <Modal
        isOpen={previewModal}
        onRequestClose={()=>closeModal(setPreviewModal)}
        style={customStyles}
      >
        <div style={{ width: 750, height: 450, backgroundColor: "white", position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <span onClick={()=>closeModal(setPreviewModal)} style={{ position: "absolute", top: 0, right: 10, fontSize: 24, cursor: "pointer" }}>x</span>
          <FilePreview base64String={selectedFile?.base64String} fileType={selectedFile?.fileType} />
        </div>
      </Modal>
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={handleCloseFailModel}
        recallFunctiononClose={handleCloseFailModel}
      />
    </div>
  );
};

export default FileUpload;
